var pic1 = require('../../assets/images/facility/transport/pic1.jpg');
var pic2 = require('../../assets/images/facility/transport/pic2.jpg');
var pic3 = require('../../assets/images/facility/transport/pic3.jpg');
var pic4 = require('../../assets/images/facility/transport/pic4.jpg');
var pic5 = require('../../assets/images/facility/transport/pic2.jpg');
const DataGalleryFacilityTransport = [
 {    
	id: 1,
	title:"transport",
    image: pic1,	    
	alt  :"transport",
  },
  {    
	id: 2,
	title:"transport",
    image: pic2,	    
	alt: "transport",
  },
  {    
	id: 3,
	title:"transport",
    image: pic3,	    
	alt: "transport",
  },
  {    
	id: 4,
	title:"transport",
    image: pic4,	    
	alt: "transport",
  },
  {    
	id: 5,
	title:"transport",
    image: pic5,	    
	alt: "transport",
  },
];
export default DataGalleryFacilityTransport;